/* eslint-disable class-methods-use-this */
/**
 * DropdownNavigation Elements have the CSS class dropdown-trigger.
 * Its next sibling element must be the element to be collapsed/opened.
 */
export default class DropdownNavigation {
    constructor() {
        this.elements = document.querySelectorAll('.dropdown-trigger');
        this.collapseBtns = document.querySelectorAll('[data-collapse-dropdown="true"]');
        this.html = document.querySelector('html');

        if (this.elements) {
            this.init();
        }
    }

    init() {
        this.elements.forEach(element => {
            const target = element.nextElementSibling;
            if(target) {
                target.classList.add('dropdown-trigger__content');
            }

            element.addEventListener('click', event => {
                if (target) {
                    event.preventDefault();

                    this.initTransitionEvent(target, element);

                    element.classList.add('is-active');
                    element.querySelector('.menu-item-arrow').classList.remove('-rotate-90');
                    element.querySelector('.menu-item-arrow').classList.add('rotate-90');
                    element.setAttribute('aria-expanded', 'true');
                    target.removeAttribute('inert');
                    target.style.minHeight = `${target.firstElementChild.scrollHeight}px`;
                    target.classList.add("h-auto"); // IE11
                }
            });
        });

        // Fix for :focus-within
        // No focus event for collapse button click/touch
        if (this.collapseBtns) {
            const preventDefaultFunction = function (event) {
                event.preventDefault();
            }

            this.collapseBtns.forEach(btn => {
                btn.addEventListener('mousedown', preventDefaultFunction, false);
                btn.addEventListener('touch', preventDefaultFunction, false);
            });
        }

        document.querySelectorAll('.dropdown-trigger__content a').forEach((el) => {
          const url = new URL(el.getAttribute('href'));
          if (window.location.pathname.includes(url.pathname)) {
            el.classList.add('active');
            el.setAttribute('aria-current', 'page');
          }
        });

    }

    /**
     * Handles click events on document.
     * If clicked Element is not part of the dropdown, dropdown will close.
     * If clicked Element's collapse-dropdown dataset has a value, dropdown will close.
     *
     * @param {Element} element
     * @param {Element} trigger
     */
    initDocumentEvent(element, trigger) {
        const documentClickListener = event => {
        const allowDocumentClick = trigger.dataset.documentClick === undefined || trigger.dataset.documentClick === "true";
        const clickTargetIsOutsideDropdown = !element.contains(event.target);
        const clickTargetTriggersCollapse = event.target.dataset.collapseDropdown;
        const clickTargetIsInTrigger = trigger.contains(event.target);

            if ((allowDocumentClick && clickTargetIsOutsideDropdown) || clickTargetIsInTrigger || clickTargetTriggersCollapse) {
                element.style.minHeight = 0;
                element.classList.remove("h-auto"); // IE11
                trigger.classList.remove('is-active');
                trigger.setAttribute('aria-expanded', 'false');
                trigger.querySelector('.menu-item-arrow').classList.remove('rotate-90');
                trigger.querySelector('.menu-item-arrow').classList.add('-rotate-90');
                element.classList.remove('is-active');
                element.setAttribute('inert', 'true');

                if (trigger.dataset.blockScrolling) {
                    this.html.classList.remove('overflow-hidden');
                }

                document.removeEventListener('click', documentClickListener);
            }
        };

		document.addEventListener('click', documentClickListener);
    }

    /**
     * Handles transitionend event on dropdown height transition.
     * Adds CSS class "is-active" to get "height: auto".
     * @param {Element} element
     * @param {Element} trigger
     */
    initTransitionEvent(element, trigger) {
        element.addEventListener('transitionend', () => {
            if (trigger.classList.contains('is-active')) {
                this.initDocumentEvent(element, trigger);
                element.classList.add('is-active');

                if (trigger.dataset.blockScrolling) {
                    this.html.classList.add('overflow-hidden');
                }
            }
        });
    }
}
